import { useEffect, useState } from "react";
import { toast } from "@/components/ui/sonner";
import { api } from "@/lib/api";
import { defaultReminderSettings } from "@/data/reminders";

export const useReminderSettings = () => {
  const [settings, setSettings] = useState(defaultReminderSettings);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadSettings = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await api.get("/reminder-settings");
        if (isMounted) setSettings(response.data);
      } catch {
        if (!isMounted) return;
        setError("Unable to load reminder settings right now.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadSettings();
    return () => {
      isMounted = false;
    };
  }, []);

  const updateField = (field, value) => setSettings((current) => ({ ...current, [field]: value }));

  const saveSettings = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError("");
    try {
      const response = await api.put("/reminder-settings", settings);
      setSettings(response.data);
      toast.success("Reminder settings saved.");
    } catch (saveError) {
      const message = saveError.response?.data?.detail || "Reminder settings could not be saved.";
      setError(message);
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  return { error, loading, saveSettings, saving, settings, updateField };
};